export enum PageEnum {
  // ログイン前のトップ画面
  TOP = '/authorization',
  // ホームページ
  BASE_HOME = '/send-mail/list?sendMail_page=1',
  // ファイル一括アップロード
  BULK_UPLOAD_FILES = '/bulk-upload-files',
}

export enum PageNumber {
  PAGE_NUMBER_1 = 1,
}

export enum PageSize {
  PAGE_SIZE_20 = 20,
  PAGE_SIZE_50 = 50,
  PAGE_SIZE_100 = 100,
  PAGE_SIZE_NO_PAGINATION = -1,
}
